
/*********************************************************************
 *
 * WARNING: This shader class is automatically generated, any manual
 * edits will be lost.
 *
 ********************************************************************/
import { ShaderBase, ShaderUniformsContainer, ShaderAttributesContainer } from '../shader';
import { Texture, CubeMapTexture } from '../../texture';
import { Context } from '../../context/Context';
import { mat3, mat4, vec2, vec3, vec4 } from "gl-matrix";
import { ShaderSourceParser } from '../shader-source-parser';

export type FullscreenCompositeShaderUniforms = {
	uTextureSampler: WebGLUniformLocation
};

export type FullscreenCompositeShaderAttributes = {
	aVertexPosition: number,
	vTextureCoord: number
};

export type FullscreenCompositeShaderSettings = string[];

export class FullscreenCompositeShader extends ShaderBase<FullscreenCompositeShaderUniforms, FullscreenCompositeShaderAttributes> {

    private static fragmentShaderSource = `
out vec4 fragColor;

uniform sampler2D uTextureSampler;
in vec2 vTextureCoord;

void main()
{
    fragColor = texture(uTextureSampler, vTextureCoord);
}
`;

    private static vertexShaderSource = `
// xy = vertex position in normalized device coordinates ([-1,+1] range).
layout(location = 0) in vec2 aVertexPosition;

out vec2 vTextureCoord;

const vec2 scale = vec2(0.5, 0.5);

void main()
{
    vTextureCoord  = aVertexPosition * scale + scale; // scale vertex attribute to [0,1] range
    gl_Position = vec4(aVertexPosition, 0.0, 1.0);
}
`;

    public override get version(): string {
        return '300 es';
    }

    public override get parser(): any {
        return new ShaderSourceParser();
    }

    protected override get warnAttributeMismatch(): boolean {
        return false;
    }

    public uniformsContainer: FullscreenCompositeShaderUniformsContainer;
    public attributesContainer: FullscreenCompositeShaderShaderAttributesContainer;

    constructor(ctx: Context, settings: FullscreenCompositeShaderSettings) {
        super(ctx, FullscreenCompositeShader.fragmentShaderSource, FullscreenCompositeShader.vertexShaderSource, settings);
        this.uniformsContainer = new FullscreenCompositeShaderUniformsContainer(ctx, this);
        this.attributesContainer = new FullscreenCompositeShaderShaderAttributesContainer(ctx, this);
    }
}

class FullscreenCompositeShaderUniformsContainer extends ShaderUniformsContainer {
    constructor(ctx: Context, private shader: FullscreenCompositeShader) {
        super(ctx);
    }

    public setTextureSampler(texture: Texture) : FullscreenCompositeShaderUniformsContainer {
        this.setTextureValue('uTextureSampler', this.shader.uniforms.uTextureSampler, texture, 'sampler2D');
        return this;
    }

    protected getTextureUniforms() {
        return [
			{ name: 'uTextureSampler', uniform: this.shader.uniforms.uTextureSampler, dataType: 'sampler2D' }
        ];
    }
}

class FullscreenCompositeShaderShaderAttributesContainer extends ShaderAttributesContainer {
    constructor(ctx: Context, private shader: FullscreenCompositeShader) {
        super(ctx);
    }

    public setVertexPosition(settings: { length: number, offset: number, itemSize: number }) : FullscreenCompositeShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.aVertexPosition, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }

    public setvTextureCoord(settings: { length: number, offset: number, itemSize: number }) : FullscreenCompositeShaderShaderAttributesContainer {
        const gl = this.gl;
        this.bindFloatAttribute(this.shader.attributes.vTextureCoord, settings.length, settings.offset, settings.itemSize, gl.FLOAT, Float32Array.BYTES_PER_ELEMENT);
        return this;
    }
}